import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { uuidv7, type Notebook, type Page } from 'shared';
import { db, saveNotebook, savePage } from '../db/db.js';
import { syncer } from '../sync/sync.js';

/** Atalho "Nova página" do ícone do app: cria e abre sem passos no meio. */
export default function NewPage(): JSX.Element {
  const navigate = useNavigate();

  useEffect(() => {
    void (async () => {
      const now = Date.now();
      let notebook = (await db.notebooks.filter((n) => !n.deletedAt).sortBy('sort'))[0];
      if (!notebook) {
        const nb: Notebook = { id: uuidv7(), title: 'Caderno', color: '#15213A', sort: 0, createdAt: now, updatedAt: now };
        await saveNotebook(nb);
        notebook = nb;
      }
      const count = await db.pages.where('notebookId').equals(notebook.id).count();
      const page: Page = {
        id: uuidv7(), notebookId: notebook.id, title: '',
        pageDate: new Date().toLocaleDateString('en-CA'),
        paper: 'ruled', sort: count, createdAt: now, updatedAt: now,
      };
      await savePage(page);
      syncer.schedule(500);
      navigate(`/p/${page.id}`, { replace: true });
    })();
  }, [navigate]);

  return <div className="center"><p className="muted">Criando página…</p></div>;
}
